import styled from "styled-components";

const TextPrimary = styled.div`
  color: ${props => props.theme.blue};
  font-size: ${props => (props.small ? "18px" : "22px")};
  font-weight: 600px;
`;

export default TextPrimary;
